import React from "react";
import { Box } from "@mui/material";

import AdgLogo from "../../assets/images/adg_logo.svg";
import InstructionImg from "../../assets/images/ins.svg";
const ThirdRes = ({ data }) => {
  const {
    BatchNo,
    ProductName,
    ManufacturingDate,
    ProductImage,
    ShortCode,
    ItemCode,
    SerialNO,
  } = data;

  const isImageNotAvail = ProductImage?.includes("no-pic") || !ProductImage;
  return (
    <Box>
      <img
        src={isImageNotAvail ? AdgLogo : ProductImage}
        alt="adg"
        style={{
          width: "80%",
          margin: "50px auto 2px auto",
          display: "block",
        }}
      />

      <ul
        style={{
          padding: "0px 20px",
        }}
      >
        <li
          style={{
            display: "flex",
            alignItems: "center",
            padding: "10px",
            border: "1px solid black",
            borderRight: 0,
            borderLeft: 0,
            backgroundColor: "#e5e5e5",
          }}
        >
          <p
            style={{
              display: "flex",
              flexBasis: "40%",
              fontSize: "14px",
            }}
          >
            Product Name
          </p>
          <p
            style={{
              display: "flex",
              flexBasis: "60%",
              fontSize: "14px",
            }}
          >
            {ProductName}
          </p>
        </li>

        <li
          style={{
            display: "flex",
            alignItems: "center",
            padding: "10px",

            backgroundColor: "#fff",
          }}
        >
          <p
            style={{
              display: "flex",
              flexBasis: "40%",
              fontSize: "14px",
            }}
          >
            Item Code :
          </p>
          <p
            style={{
              display: "flex",
              flexBasis: "60%",
              fontSize: "14px",
            }}
          >
            {ItemCode}
          </p>
        </li>

        {ShortCode ? (
          <li
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px",
              borderTop: "1px solid #000",
              borderBottom: "1px solid #000",
              backgroundColor: "#e5e5e5",
            }}
          >
            <p
              style={{
                display: "flex",
                flexBasis: "40%",
                fontSize: "14px",
              }}
            >
              Model
            </p>
            <p
              style={{
                display: "flex",
                flexBasis: "60%",
                fontSize: "14px",
              }}
            >
              {ShortCode}
            </p>
          </li>
        ) : null}

        {BatchNo ? (
          <li
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px",
              borderBottom: "1px solid #000",
              backgroundColor: "#fff",
            }}
          >
            <p
              style={{
                display: "flex",
                flexBasis: "40%",
                fontSize: "14px",
              }}
            >
              Batch No :
            </p>
            <p
              style={{
                display: "flex",
                flexBasis: "60%",
                fontSize: "14px",
              }}
            >
              {BatchNo}
            </p>
          </li>
        ) : null}
        {SerialNO ? (
          <li
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px",
              borderBottom: "1px solid #000",
              backgroundColor: "#e5e5e5",
            }}
          >
            <p
              style={{
                display: "flex",
                flexBasis: "40%",
                fontSize: "14px",
              }}
            >
              Serial No
            </p>
            <p
              style={{
                display: "flex",
                flexBasis: "60%",
                fontSize: "14px",
              }}
            >
              0{SerialNO}
            </p>
          </li>
        ) : null}
      </ul>

      <Box
        style={{
          padding: "10px 20px",
        }}
      >
        {/* <h4>Meets:</h4> */}

        <ul
          style={{
            display: "flex",
            flexWrap: "wrap",
          }}
        >
          <li
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: "5px",
            }}
          >
            <h5
              style={{
                width: "35%",
              }}
            >
              DESCRIPTION:
            </h5>

            <p
              style={{
                display: "flex",
                flexBasis: "70%",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              100% COTTON TFR JACKET 470 GSM (JACKET WITH COLLAR &
                FRONT CLOSURE WITH SNAP & VELCRO, TWO CHEST POCKET COVERED WITH FLAP)

              {/* 100% COTTON TFR JACKET 470 GSM (JACKET WITH COLLAR & FRONT CLOSURE
              WITH PLASTIC SNAP WITH VELCRO, TWO CHEST POCKET) FABRIC */}
            </p>
          </li>

          <li
            style={{
              display: "flex",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            <h5
              style={{
                width: "35%",
              }}
            >
              CERTIFICATION:
            </h5>

            <p
              style={{
                display: "flex",
                flexBasis: "70%",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              EN ISO 11612:2015 : A1 B1 C1 E3 F2
            </p>
          </li>

          <li
            style={{
              display: "flex",
              alignItems: "flex-start",
              width: "100%",
            }}
          >
            <h5
              style={{
                width: "35%",
                visibility: "hidden",
              }}
            >
              CERTIFICATION:
            </h5>

            <p
              style={{
                display: "flex",
                flexBasis: "70%",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              ASTM F1959 : ATPV 24 Cal/cm<sup>2</sup>
            </p>
          </li>

          <li
            style={{
              display: "flex",
              alignItems: "flex-start",
              marginBottom: "5px",
              width: "100%",
            }}
          >
            <h5
              style={{
                width: "35%",
                visibility: "hidden",
              }}
            >
              CERTIFICATION:
            </h5>

            <p
              style={{
                display: "flex",
                flexBasis: "70%",
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
            EN 1149, OEKO TEX 100
            </p>
          </li>

          <li
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            <h5
              style={{
                width: "33%",
              }}
            >
              COLOUR:
            </h5>

            <div
              className="d-flex flex-column align-items-start"
              style={{
                flex: 1,
              }}
            >
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "bold",
                }}
              >
                BICOLOUR (ORNAGE/NAVY)
              </p>
            </div>
          </li>
        </ul>
      </Box>
      <p className="border-bottom-2"></p>
      <Box padding="10px 20px">
        <h4
          style={{
            textDecoration: "underline",
            textAlign: "center",
            color: "black",
            marginBottom: "20px",
          }}
        >
          WASHING INSTRUCTIONS
        </h4>

        <img
          src={InstructionImg}
          alt="instrucations"
          style={{
            width: "100%",
          }}
        />
        <Box>
          <p className="d-flex items-center gap-2 f-12 font-bold">
            <span className="dot" /> Wash at maximum 60°C
          </p>

          <p className="d-flex items-center gap-2 f-12 font-bold">
            <span className="dot" /> Never use chlorine bleach
          </p>

          <p className="d-flex items-center gap-2 f-12 font-bold">
            <span className="dot" /> Use liquid detergents only
          </p>

          <p className="d-flex items-center gap-2 f-12 font-bold">
            <span className="dot" /> Do not iron
          </p>

          <p className="d-flex items-center gap-2 f-12 font-bold">
            <span className="dot" /> Do not dry clean
          </p>

          <p className="d-flex items-center gap-2 f-12 font-bold">
            <span className="dot" /> Tumble dry low heat
          </p>

          <p className="d-flex items-center gap-2 f-12 font-bold">
            <span className="dot" /> Wash in an industrial washer
          </p>
        </Box>
      </Box>

      <Box padding="10px 20px">
        <p className="f-12 font-bold mb-2">Manufactured &amp; Marketed by : </p>
        <img
          src="https://qr.udyogisafety.com/product/Image/udyogi-logo.svg"
          alt="udyogi-logo"
          style={{ width: "50%" }}
        />
        <p className="f-12 font-bold">Udyogi Plastics Pvt. Ltd.</p>
        <p className="f-12 font-bold">294, B. B. Ganguly Street, 2nd Floor,</p>
        <p className="f-12 font-bold">Kolkata - 700012, India</p>
        <p className="f-12 font-bold">E-mail : info@udyogi.net</p>
        <p className="f-12 font-bold">www.udyogisafety.com</p>
      </Box>
    </Box>
  );
};
export default ThirdRes;
